import { UIDateFormat, UITimeFormat } from "@helpers/dates";
import moment from "moment";
import React from "react";
import { DateInput, TimeInput } from "semantic-ui-calendar-react";
import { Form } from "semantic-ui-react";

function extractDate(datetime) {
  return moment(datetime).format(UIDateFormat);
}

function extractTime(datetime) {
  return moment(datetime).format(UITimeFormat);
}

const DateTimeGroupInput = (props) => {
  const { label, name, datetime, disabled, onChange } = props;

  const handleDateChange = (event, { name, value }) => {
    const time = moment(datetime).format(UITimeFormat);
    updateDate(name, value, time);
  };

  const handleTimeChange = (event, { name, value }) => {
    let date = moment(datetime).format(UIDateFormat);
    updateDate(name, date, value);
  };

  const updateDate = (name, date, time) => {
    onChange(
      name,
      moment(`${date} ${time}`, `${UIDateFormat} HH:mm`).toISOString(true),
    );
  };

  return (
    <Form.Field inline className="pl-0">
      <label style={{ width: "50px" }}>{label}:</label>
      <DateInput
        className="ui input"
        name={name}
        placeholder="Date"
        value={extractDate(datetime)}
        iconPosition="left"
        inlineLabel
        onChange={handleDateChange}
        animation="fade"
        popupPosition="bottom center"
        disabled={disabled}
        style={{ width: "130px" }}
        closable
        autoComplete="off"
        dateFormat={UIDateFormat}
      />
      <TimeInput
        className="ui input ml-0_5"
        name={name}
        placeholder="Time"
        value={extractTime(datetime)}
        iconPosition="left"
        inlineLabel
        onChange={handleTimeChange}
        animation="fade"
        popupPosition="bottom center"
        disabled={disabled}
        closable
        style={{ width: "90px" }}
        autoComplete="off"
      />
    </Form.Field>
  );
};

export default DateTimeGroupInput;
